import type { ClanMember } from "../lib/api";
import { useT } from "../i18n";
import type { TFn } from "../i18n";

type Member = ClanMember;

function displayName(m: Member, t: TFn): string {
  return m.nickname || t("members.fallbackName");
}

function initial(m: Member, t: TFn): string {
  const name = displayName(m, t).trim();
  return name ? name[0].toUpperCase() : t("members.unknownInitial");
}

export default function MemberList({ members }: { members: Member[] }) {
  const { t } = useT();
  return (
    <section>
      <div className="flex items-center justify-between mb-2">
        <h2 className="text-base font-bold">{t("members.title")}</h2>
        <span className="text-muted text-sm">{members.length}</span>
      </div>

      <div className="bg-card border border-line-2 rounded-[16px] divide-y divide-white/5">
        {members.map((m, i) => (
          <div key={`${displayName(m, t)}-${i}`} className="flex items-center gap-3 p-4">
            <span className="w-9 h-9 shrink-0 rounded-full bg-violet-t14 text-violet-lighter flex items-center justify-center text-sm font-semibold">
              {initial(m, t)}
            </span>
            <span className="flex-1 text-sm">{displayName(m, t)}</span>
            {m.role === "leader" && (
              <span className="text-xs font-medium text-gold bg-gold/10 rounded-full px-2.5 py-1">{t("members.leader")}</span>
            )}
          </div>
        ))}
        {members.length === 0 && <div className="p-4 text-muted text-sm">{t("members.empty")}</div>}
      </div>
    </section>
  );
}
